<template>
        <div class="flex flex-col h-full w-full px-2">
            <h3>{{ CardTitle }}</h3>
            <card-form
                ref="cardRef"
                :meta="orgCardMeta"
                :to-remove-toolbar-items-names="ToRemoveButtons"
                components-path="views/nsi/components/forms/org-structure-form"
                :use-default-buttons="true"
                :default-handlers="{ refresh: null, commit: null }"
                :callbacks="{refreshData: refreshData, saveData: saveData, isDirty: null, getUserData: getUserData}"
            />
        </div>
</template>
<script setup>

import { getNsiOrgCardData, saveNsiOrgCard } from '@/service/nsi-service';
//import {useRoute} from "vue-router";
import CardForm from '@/components/card-component/card-form.vue';

import { ref } from 'vue';

//const route = useRoute();

const CardTitle = ref();

const cardRef = ref();

let v_pr_new = false;
let v_id = 0;
let v_parent_id = 0;

const refreshData = async () => {
    if ((v_pr_new === false) && (v_id === 0)) {
        return;
    }
    const tmpSource = await getNsiOrgCardData(v_id, v_parent_id);
    CardTitle.value = tmpSource.data.path;
    return tmpSource;
}

const SetId = (id, parent_id) => {
    v_id = id;
    if (!parent_id)
        v_parent_id = 0;
    else
        v_parent_id = parent_id;
    if (v_id === 0) v_pr_new = true;
}

const forceRefresh = () => {
        cardRef.value.onRefreshDataButtonClick();
    }


defineExpose({SetId, forceRefresh});

const emit = defineEmits(['NewItemSaved']);

const saveData = async data => {
    const response = await saveNsiOrgCard(data);
    if ((response.result) && (response.success)) {
        if (response.kodp)
            v_id = response.kodp;
        emit('NewItemSaved', 'org_' + v_id);
    }
    return response;
};

const getUserData = async() => {
    return { result: true, changes: [] };
}

const ToRemoveButtons = [
  'refresh',
  'copy',
  'edit',
  'delete'
];

const orgCardMeta = {
    groups: [
        {
            id: 1,
            label: 'Основные реквизиты',
            collapsed: false,
        },
    ],
    components: [
        // GROUP 1

        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'ID',
            groupId: 1,
            size: [1, 1],
            fieldNameText: 'kodp',
        },
        {
            fieldType: 'ai-form-lookup',
            title: 'Состояние',
            groupId: 1,
            size: [1, 1],
            fieldNameId: 'pr_active',
            fieldNameText: 'status_name',
            extParams: {
                displayExpr: 'name',
                valueExpr: 'pr_active',
                dictionaryRoutePath: 'counteragent./customer/dict/status/get',
            },
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Краткое наименование',
            groupId: 1,
            size: [1, 4],
            fieldNameText: 'sname',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Наименование',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'name',
        },
        {
            fieldNameId: 'kod_ecls',
            title: 'Отношение к энергосистеме',
            name: 'org-structure-select-box',
            fieldNameText: 'ecls_name',
            groupId: 1,
            size: [1, 3],
            extParams: {
                displayExpr: 'name',
                valueExpr: 'kod_ecls',
                dictionaryRoutePath: 'counteragent./nsi/org-cls/list/get',
                argsExpr: ['kod_parent'],
            },
        },
        {
            fieldNameId: 'kod_separator',
            title: 'Уровень организации',
            name: 'org-structure-select-box',
            fieldNameText: 'separator_name',
            groupId: 1,
            size: [1, 3],
            extParams: {
                displayExpr: 'name',
                valueExpr: 'kod_separator',
                dictionaryRoutePath: 'counteragent./nsi/org-orgseparator/list/get',
                argsExpr: ['kod_parent', 'kod_ecls'],
            },
        },
        {
            fieldNameId: 'tep_el',
            title: 'Вид энергии',
            fieldType: 'ai-form-lookup',
            fieldNameText: 'tep_el_name',
            groupId: 1,
            size: [1, 2],
            extParams: {
                displayExpr: 'name',
                valueExpr: 'tep_el',
                dictionaryRoutePath: 'counteragent./customer/dict/tep_el/get',
            },
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Префикс счетов-фактур',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'pref_fac',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Префикс документов',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'pref_doc',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Телефон',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'tel',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Факс',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'fax',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Адрес электронной почты',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'email',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Примечание',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'prim',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Местонахождение',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'place',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Широта (градусы)',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'latitude',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Долгота (градусы)',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'longitude',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Код подразделения',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'kod_org',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'WWW-адрес',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'site',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Доп. информация',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'info',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Адрес (нац. язык)',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'address_nation_lang',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Классификатор субъектов рынка',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'group_elmarket',
        },
    ],
};


</script>
